import React from "react";
import NavigateButton from "../../../components/buttonsNavigate";
import {
  FaArrowLeft,
  FaCheckCircle,
  FaHistory,
  FaListUl,
  FaSearch,
  FaShoppingCart,
  FaTruck,
  FaBoxOpen,
  FaBarcode,
  FaBuilding
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { LiaTruckPickupSolid } from "react-icons/lia";
import { TbTransfer } from "react-icons/tb";
import { MdRestorePage } from "react-icons/md";
const OrderPage = () => {
  const history = useNavigate();
  const permissions = JSON.parse(localStorage.getItem("permissions"));
  return (
    <>
      <div className=" mb-5 sticky top-0 flex flex-col bg-white">
        <div className=" w-full bg-dbase h-16">
          <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
            <button onClick={() => history(-1)}>
              <FaArrowLeft />
            </button>
            <h2 className=" text-xl    my-auto">Order</h2>
          </div>
        </div>
      </div>
      <div className=" grid grid-cols-2 container gap-x-6 gap-y-4">
        {(window.location.host === "pda.ishtari.com.gh" || window.location.host === "pda.energyplus-lb.com") && (
          <>
            <NavigateButton
              icon={<FaHistory />}
              name={"CHANGE STATUS"}
              arname={"تغيير الحالة"}
              color={"bg-Orangeflo"}
              onclick={() => history("changestatus")}
            />
            <NavigateButton
              icon={<FaSearch />}
              name={"Order Details"}
              arname={"الطلبية"}
              color={"bg-[rgb(14,165,233)]"}
              onclick={() => history("order")}
            />
            {/* <NavigateButton
              name={"Get Data Entry Product"}
              icon={<FaShoppingCart />}
              arname={" بيانات المنتج المدخلة "}
              color={"bg-dbase"}
              onclick={() => history("getorder")}
            /> */}
            <NavigateButton
              icon={<FaListUl />}
              name={"Prepare ORDER"}
              arname={" تحضير المنتج"}
              color={"bg-[rgb(245,158,11)]"}
              onclick={() => history("orderproduct")}
            />
            {/* <NavigateButton
               icon={<FaHistory />}
               name={"ORDERS HISTORY"}
               arname={" تاريخ الطلبات"}
               color={"bg-[rgb(7,89,133)]"}
               onclick={() => history("ordershistory")}
             /> */}

            <NavigateButton
              icon={<FaHistory />}
              name={"Order Status History "}
              arname={"سجل الطلب"}
              color={"bg-[rgb(7,89,133)]"}
              onclick={() => history("orderhistory")}
            />

            <NavigateButton
              icon={<LiaTruckPickupSolid />}
              name={"PickUp Order"}
              arname={" استلام الطلبية"}
              color={"bg-[rgb(145,170,255)]"}
              onclick={() => history("pickuporder")}
            />
            <NavigateButton
              icon={<FaBoxOpen />}
              name={"Missing Products"}
              arname={"المنتجات المفقودة"}
              color={"bg-[rgb(156,39,176)]"}
              onclick={() => history("missingproducts")}
            />
            <NavigateButton
              icon={<FaTruck />}
              name={"Restock Awaiting failed ready"}
              arname={"طلب إعادة تخزين "}
              color={"bg-[rgb(90,74,255)]"}
              onclick={() => history("restockorder")}
            />
            <NavigateButton
              icon={<FaBarcode />}
              name={"Scan Logistics Order"}
              arname={"مسح طلب لوجستي"}
              color={"bg-[rgb(76,175,80)]"}
              onclick={() => history("scannlogisticsorder")}
            />
          </>
        )}
        {(window.location.host.startsWith("localhost") || window.location.host === "pda.ishtari.com" || window.location.host === "pda.energyplus-lb.com") && (
          <>
            {permissions.pda_order_change_status && (
              <NavigateButton
                icon={<FaHistory />}
                name={"CHANGE STATUS"}
                arname={"تغيير الحالة"}
                color={"bg-Orangeflo"}
                onclick={() => history("changestatus")}
              />
            )}

            {permissions.pda_order_search_order && (
              <NavigateButton
                icon={<FaSearch />}
                name={"Order Details"}
                arname={"الطلبية"}
                color={"bg-[rgb(14,165,233)]"}
                onclick={() => history("order")}
              />
            )}

            {/* {permissions.pda_order_get_data_entry_product && (
              <NavigateButton
                name={"Get Data Entry Product"}
                icon={<FaShoppingCart />}
                arname={" بيانات المنتج المدخلة "}
                color={"bg-dbase"}
                onclick={() => history("getorder")}
              />
            )} */}
            {permissions.pda_order_product && (
              <NavigateButton
                icon={<FaListUl />}
                name={"Prepare ORDER"}
                arname={" تحضير المنتج"}
                color={"bg-[rgb(245,158,11)]"}
                onclick={() => history("orderproduct")}
              />
            )}
            {/* {permissions.pda_order_ordres_history && (
               <NavigateButton
               icon={<FaHistory />}
               name={"ORDERS HISTORY"}
               arname={" تاريخ الطلبات"}
               color={"bg-[rgb(7,89,133)]"}
               onclick={() => history("ordershistory")}
             />
            )} */}

            {permissions.pda_order_order_history && (
              <NavigateButton
                icon={<FaHistory />}
                name={"Order Status History "}
                arname={"سجل الطلب"}
                color={"bg-[rgb(7,89,133)]"}
                onclick={() => history("orderhistory")}
              />
            )}

            {permissions.pda_order_pickup_order && (
              <NavigateButton
                icon={<LiaTruckPickupSolid />}
                name={"PickUp Order"}
                arname={" استلام الطلبية"}
                color={"bg-[rgb(145,170,255)]"}
                onclick={() => history("pickuporder")}
              />
            )}
            {permissions.pda_order_missing_products && (
              <NavigateButton
                icon={<FaBoxOpen />}
                name={"Missing Products"}
                arname={"المنتجات المفقودة"}
                color={"bg-[rgb(156,39,176)]"}
                onclick={() => history("missingproducts")}
              />
            )}
            {permissions.pda_order_scanne_logistic_order && (
              <NavigateButton
                icon={<FaBarcode />}
                name={"Scan Logistics Order"}
                arname={"مسح طلب لوجستي"}
                color={"bg-[rgb(76,175,80)]"}
                onclick={() => history("scannlogisticsorder")}
              />
            )}
            {permissions.pda_order_restock_order && (
              <NavigateButton
                icon={<MdRestorePage className=" text-3xl" />}
                name={"Restock Awaiting failed ready"}
                arname={"طلب إعادة تخزين "}
                color={"bg-[rgb(90,74,255)]"}
                onclick={() => history("restockorder")}
              />
            )}
            {permissions.pda_order_pickup_floor && (
              <NavigateButton
                icon={<FaBuilding />}
                name={"PickUp Floor"}
                arname={"طابق الاستلام"}
                color={"bg-[rgb(196,170,255)]"}
                onclick={() => history("pickupfloor")}
              />
            )}
          </>
        )}

      </div>
    </>
  );
};

export default OrderPage;
